/**
 * Cart Item V2 Web Component
 * Uses theme's native cart-drawer refresh pattern
 */

if (!customElements.get('cart-item-v2')) {
  class CartItemV2 extends HTMLElement {
    connectedCallback() {
      this.index = this.dataset.index;
      this.bindEvents();
    }

    bindEvents() {
      const qtyInput = this.querySelector('.js-qty-input');
      const minusBtn = this.querySelector('.js-qty-minus');
      const plusBtn = this.querySelector('.js-qty-plus');
      const deleteBtn = this.querySelector('.js-remove-item');

      minusBtn?.addEventListener('click', () => {
        const qty = parseInt(qtyInput.value, 10);
        this.updateCart(qty > 1 ? qty - 1 : 0);
      });

      plusBtn?.addEventListener('click', () => {
        const qty = parseInt(qtyInput.value, 10);
        this.updateCart(qty + 1);
      });

      qtyInput?.addEventListener('change', () => {
        const qty = parseInt(qtyInput.value, 10);
        this.updateCart(qty < 1 ? 1 : qty);
      });

      deleteBtn?.addEventListener('click', () => {
        this.updateCart(0);
      });
    }

    async updateCart(quantity) {
      const cartDrawer = document.querySelector('cart-drawer');
      this.showLoader(cartDrawer);

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: parseInt(this.index, 10),
            quantity: quantity,
          }),
        });

        if (!response.ok) throw new Error('Cart update failed');

        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      } catch (error) {
        console.error('Cart update error:', error);
        this.hideLoader();
      }
    }

    showLoader(container) {
      if (!container) return;
      let loader = container.querySelector('.cart-drawer-loader');
      if (!loader) {
        loader = document.createElement('div');
        loader.className = 'cart-drawer-loader';
        loader.innerHTML = '<div class="cart-drawer-loader__spinner"></div>';
        container.appendChild(loader);
      }
      loader.classList.add('is-visible');
    }

    hideLoader() {
      document.querySelector('cart-drawer')?.hideCartDrawerLoader?.();
      const loader = document.querySelector('.cart-drawer-loader');
      loader?.classList.remove('is-visible');
    }
  }

  customElements.define('cart-item-v2', CartItemV2);
}

/**
 * Cart Items Container V2
 */
if (!customElements.get('cart-items-v2')) {
  class CartItemsV2 extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section || 'cart-drawer';
    }
  }

  customElements.define('cart-items-v2', CartItemsV2);
}
